
<transition
	name="sliding-sheet-overlay"
	appear
>
	<div
		v-if="isOpen"
		class="sliding-sheet-overlay"
		@click="handleOverlayClick"
	>
		<transition
			name="sliding-sheet"
			appear
		>
			<div
				v-if="isOpen"
				class="sliding-sheet"
				:class="sheetClasses"
				:style="sheetStyle"
				@click.stop
			>
				<div class="sliding-sheet-header">
					<div class="sliding-sheet-title">
						<slot name="header">
							<h3>
								{{ title }}
							</h3>
						</slot>
					</div>
					<button
						class="sliding-sheet-close"
						:aria-label="closeButtonAriaLabel"
						@click="$emit('close')"
					>
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
						>
							<line
								x1="18"
								y1="6"
								x2="6"
								y2="18"
							/>
							<line
								x1="6"
								y1="6"
								x2="18"
								y2="18"
							/>
						</svg>
					</button>
				</div>

				<div class="sliding-sheet-content overflow-y-auto">
					<slot name="content">
						<slot />
					</slot>
				</div>

				<div
					v-if="$slots.footer"
					class="sliding-sheet-footer text-right"
				>
					<slot name="footer" />
				</div>
			</div>
		</transition>
	</div>
</transition>
